const PlayOutlinedIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <g clipPath='url(#clip0_12223_88259)'>
        <path
          d='M6.75 3.73802V20.2605C6.75245 20.3924 6.78962 20.5212 6.85776 20.6341C6.9259 20.747 7.0226 20.84 7.13812 20.9036C7.25364 20.9672 7.38388 20.9992 7.51572 20.9964C7.64756 20.9936 7.77634 20.9561 7.88906 20.8877L21.3966 12.6265C21.5045 12.5612 21.5937 12.4691 21.6556 12.3593C21.7175 12.2494 21.7501 12.1254 21.7501 11.9993C21.7501 11.8732 21.7175 11.7492 21.6556 11.6393C21.5937 11.5294 21.5045 11.4374 21.3966 11.3721L7.88906 3.11084C7.77634 3.04241 7.64756 3.00491 7.51572 3.00212C7.38388 2.99933 7.25364 3.03136 7.13812 3.09496C7.0226 3.15857 6.9259 3.25151 6.85776 3.36441C6.78962 3.47731 6.75245 3.60618 6.75 3.73802Z'
          stroke='#735BF2'
          strokeWidth='1.5'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_12223_88259'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default PlayOutlinedIcon
